import React from 'react'
import { useNavigate } from 'react-router-dom'
import Helpers from '../../Helpers/Helpers'
import Notification from '../../Helpers/Notification'
import { SPECIALIZATION_LABELS, LANGUAGE_LABELS } from '../../constants/labels'
import './AstrologerCard.css'

const AstrologerCard = ({ astrologer }) => {
    const navigate = useNavigate();
    const helpers = Helpers()
    
    const initiateChat = async (astrologerId) => {
        const response = await helpers.httpRequest(`/chat/create`, 'POST', { astrologerId })
        console.log('response', response);
        Notification(response.status, response.message);

        if (response.status === 'success') {
            navigate(`/chat/${response.data._id}`)
        }
    }

    // Determine avatar display
    const avatarUrl = astrologer.full_profile_pic
    const showImg = avatarUrl && !avatarUrl.includes('default-profile_pic')
    const getInitials = (nameStr) => {
        if (!nameStr) return ''
        const parts = nameStr.trim().split(' ')
        if (parts.length === 1) return parts[0][0].toUpperCase()
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    }

    // Rating display logic
    const renderRatingStars = () => {
        const rating = astrologer?.ratingDetails?.rating || 0
        const isNew = !astrologer?.ratingDetails?.personCount
        
        return (
            <div className="stars-container">
                {Array.from({ length: 5 }).map((_, idx) => {
                    if (isNew) {
                        return <span key={idx} className="star empty">★</span>
                    }
                    
                    const starValue = idx + 1
                    const difference = rating - idx

                    if (difference >= 1) {
                        return <span key={idx} className="star">★</span>
                    } else if (difference > 0 && difference <= 1) {
                        return <span key={idx} className="star half">★</span>
                    } else {
                        return <span key={idx} className="star empty">★</span>
                    }
                })}
            </div>
        )
    }

    const formatRating = (rating) => {
        return Number(rating).toFixed(1)
    }

    return (
        <div className="astro-card">
            <div className="avatar-wrapper">
                <span className={`status-dot ${astrologer.is_online ? 'online' : 'offline'}`}></span>
                {showImg ? (
                    <img className="avatar" src={avatarUrl} alt={astrologer.name} />
                ) : (
                    <div className="avatar-initials">{getInitials(astrologer.name)}</div>
                )}
                
                <div className="avatar-rating">
                    {renderRatingStars()}
                    {astrologer?.ratingDetails?.personCount > 0 ? (
                        <span className="rating-count">
                            ({formatRating(astrologer.ratingDetails.rating)}) {astrologer.ratingDetails.personCount} chats
                        </span>
                    ) : (
                        <span className="rating-count new">New!</span>
                    )}
                </div>
            </div>

            <div className="details">
                <h5 className="name">{astrologer.name}</h5>
                <p className="spec astrologer-specialization">{SPECIALIZATION_LABELS[astrologer.specialization] || astrologer.specialization || 'General Astrology'}</p>
                <p className="langs astrologer-language">{LANGUAGE_LABELS[astrologer.language] || astrologer.language || 'English'}</p>
                <p className="exp astrologer-experience">Experience: {astrologer.year_of_exp || 0} Years</p>
                <div className="price">₹ {astrologer.fees || 0}/min</div>
            </div>

            <div className="action">
                <button
                    className={`chat-btn ${astrologer.is_online ? 'online' : 'offline'}`}
                    onClick={() => {
                        if (!astrologer.is_online) {
                            Notification('error', 'Astrologer is offline!')
                            return
                        }
                        initiateChat(astrologer.id)
                    }}
                    disabled={!astrologer.is_online}
                >
                    Chat
                </button>
            </div>
        </div>
    )
}

export default AstrologerCard
